import values from 'lodash/values'
import { createSelector } from 'reselect'
import { ILoad, ILoadsState, ILoadCountsState } from 'apps/fleet-planner/types/loads'
import { IStore } from 'apps/fleet-planner/utils/types/store'
import { selectDriversId } from './drivers'

const loadsStateSelector = (state: IStore): ILoadsState => state.loads
export const selectLoads = createSelector(loadsStateSelector, ({ data }) => data.loads?.byId ?? {})
export const selectLoadIds = createSelector(loadsStateSelector, ({ data }) => data.loadIds)

export const selectSampleLoadId = createSelector(
  loadsStateSelector,
  ({ data }) => values(data.loads.byId).filter(l => l.isSample)[0]?.id
)

const loadIdSelector = (state: IStore, loadId: string): string => loadId
export const selectLoadById = createSelector(
  [selectLoads, loadIdSelector],
  (loadsById: { [id: string]: ILoad }, loadId: string) => loadsById[loadId]
)

const driverIdSelector = (state: IStore, driverId: string): string => driverId
export const selectLoadsByDriverId = createSelector(
  [selectLoads, driverIdSelector],
  (loadsById: { [id: string]: ILoad }, driverId: string) =>
    driverId
      ? values(loadsById).filter(l => l.drivers?.filter(d => d.id === driverId).length)
      : values(loadsById).filter(l => !l.drivers?.length)
)

export const selectLoadsByDrivers = createSelector(
  [selectLoads, selectDriversId],
  (
    loadsById: { [id: string]: ILoad },
    driverIds: (string | undefined)[]
  ): { [driverId: string]: ILoad[] } => {
    driverIds.unshift(undefined) // This is a hack to also get the list of unassigned loads
    // TODO: refactor the Fleet view so each bars can be loaded individually instead of this ugly collection
    return driverIds.reduce(
      (acc, driverId) => ({
        ...acc,
        ...{
          [driverId ?? 'unassigned']: driverId
            ? values(loadsById).filter(l => l.drivers?.filter(d => d.id === driverId).length)
            : values(loadsById).filter(
                l => !l.drivers?.length || l.drivers?.findIndex(d => !d.id) >= 0 // Takes loads with no drivers or no matched drivers assigned (external loads)
              ),
        },
      }),
      {}
    )
  }
)

export const selectLoadsFetching = createSelector(loadsStateSelector, ({ fetching }) => fetching)
export const selectLoadstotalCount = createSelector(
  loadsStateSelector,
  ({ totalCount }) => totalCount
)
export const selectLoadsParams = createSelector(loadsStateSelector, ({ params }) => params)
export const selectLoadsError = createSelector(loadsStateSelector, ({ error }) => error)
export const selectLoadsActiveTab = createSelector(loadsStateSelector, ({ activeTab }) => activeTab)
export const selectLastCreatedLoad = createSelector(
  loadsStateSelector,
  ({ lastCreatedLoad }) => lastCreatedLoad
)

const loadCountsStateSelector = (state: IStore): ILoadCountsState => state.loadCounts
export const selectLoadCounts = createSelector(loadCountsStateSelector, ({ counts }) => counts)

export const selectLoadLabels = createSelector(loadsStateSelector, ({ data }) => [
  ...new Set(
    Object.values(data.loads.byId)
      .map(load => load.customerLabels || [])
      .flat(1)
  ),
])
